/*
 * Manage Install - Container
 */

import { IinstallBasePopulated } from '../../models';
import {
    deleteInstall,
    saveInstall,
    toggleEditInstallModal,
    updateInstall,
    bulkUpdateInstalls,
    setEnableInstallBatchMode,
    setInstallFormValues,
    updateInstallFormValues
} from '../../actions/manageInventoryActions';

import EditInstallForm from './EditInstallForm';
import { RouteComponentProps } from 'react-router';
import { TFunction } from 'i18next';
import { cleanFacility } from '../../reducers/facilitiesReducer';
import { connect } from 'react-redux';
import { saveAnyLocation } from '../../actions/manageLocationActions';
import { withTranslation, WithTranslation } from 'react-i18next';
import { IinitialState } from '../../reducers';
import { selectIsLoading, selectIsOnlineAndEmptyQueue } from '../../reducers/commonReducers';
import { selectIsJobReadOnly } from '../../reducers/commonSelectors';
import filter from 'lodash/filter';
import { initialMeasurmentPointResult } from '../../reducers/initialState';

interface Iprops extends RouteComponentProps<any> {
    selectedItem: IinstallBasePopulated;
    colorButton: string;
    t: TFunction;
}

const mapStateToProps = (state: IinitialState, ownProps: Iprops & WithTranslation) => {
    const cleanedFacility = cleanFacility(state.facilities.facilitiesByID[state.manageJob.selectedJob.facilityID]);
    const selectedJob = state.manageJob.selectedJob;
    let selectedProduct = ownProps.selectedItem.product?.id
        ? ownProps.selectedItem.product
        : state.manageInventory.selectedProduct;
    let mainCategoryID = '';

    // Check if selectedProduct actually got set, if it didn't, check if the user is bulk editing assets
    if (selectedProduct?.id === '') {
        if (state.manageInventory.selection && state.manageInventory.selection.length > 0) {
            // They are bulk editing, so let's populate the form with the 1st one?
            const selectedInstallBaseIDs = state.manageInventory.selection.map(item => {
                return item.split('select-')[1];
            });

            const filteredInstallBases = filter(
                state.manageInventory.installBasesByID,
                installBase => selectedInstallBaseIDs.indexOf(installBase.id) !== -1
            );
            if (filteredInstallBases.length > 0) {
                const filteredProducts = filteredInstallBases.map(value => {
                    return state.manageInventory.productsByID[value.materialID];
                });

                // For now, only going to populate the modal if 1 installbase was selected
                // If you are editing multiple, we are not prepopulating, and only changing
                // data that is entered new
                if (filteredProducts.length === 1 && filteredProducts[0]) {
                    selectedProduct = filteredProducts[0];
                    const populated: IinstallBasePopulated = {
                        product: selectedProduct,
                        ...filteredInstallBases[0],
                        materialID: filteredInstallBases[0]?.materialID || '',
                        facilityID: filteredInstallBases[0]?.facilityID || '',
                        measurementPointListResultStatus:
                            filteredInstallBases[0]?.measurementPointListResultStatus || 0,
                        workOrderResultStatus: filteredInstallBases[0]?.workOrderResultStatus || 0,
                        latestMeasurementPointListResultID:
                            filteredInstallBases[0]?.latestMeasurementPointListResultID || '',
                        latestAGSMeasurementPointListResultID:
                            filteredInstallBases[0]?.latestAGSMeasurementPointListResultID || '',
                        latestCommissioningMeasurementPointListResultID:
                            filteredInstallBases[0]?.latestCommissioningMeasurementPointListResultID || '',
                        latestVerificationMeasurementPointListResultID:
                            filteredInstallBases[0]?.latestVerificationMeasurementPointListResultID || '',
                        latestAuditMeasurementPointListResultID:
                            filteredInstallBases[0]?.latestAuditMeasurementPointListResultID || '',
                        latestMaintenanceMeasurementPointListResultID:
                            filteredInstallBases[0]?.latestMaintenanceMeasurementPointListResultID || '',
                        latestRepairMeasurementPointListResultID:
                            filteredInstallBases[0]?.latestRepairMeasurementPointListResultID || '',
                        latestServicePlanMeasurementPointListResultID:
                            filteredInstallBases[0]?.latestServicePlanMeasurementPointListResultID || '',
                        latestWarrantyMeasurementPointListResultID:
                            filteredInstallBases[0]?.latestWarrantyMeasurementPointListResultID || '',
                        lastQuarterlyMaintenanceDate: filteredInstallBases[0]?.lastQuarterlyMaintenanceDate || '',
                        lastSixMonthMaintenanceDate: filteredInstallBases[0]?.lastSixMonthMaintenanceDate || '',
                        lastYearlyMaintenanceDate: filteredInstallBases[0]?.lastYearlyMaintenanceDate || '',
                        lastTwoYearMaintenanceDate: filteredInstallBases[0]?.lastTwoYearMaintenanceDate || '',
                        lastThreeYearMaintenanceDate: filteredInstallBases[0]?.lastThreeYearMaintenanceDate || '',
                        lastFiveYearMaintenanceDate: filteredInstallBases[0]?.lastFiveYearMaintenanceDate || '',
                        objectPartGroup: filteredInstallBases[0]?.objectPartGroup || '',
                        id: filteredInstallBases[0]?.id || '',
                        isDeleted: filteredInstallBases[0]?.isDeleted ?? false,
                        productNameString: '',
                        locationString: '',
                        activityDescriptionString: undefined,
                        woNumberString: undefined,
                        workOrderID: undefined,
                        latestMeasurementPointListResult: initialMeasurmentPointResult,
                        originalMeasurementPointListResultStatus: 0,
                        isVirtual: false,
                        isDecommissioned: false
                    };

                    ownProps.selectedItem = populated;
                }
            }
        }
    }

    if (selectedProduct && selectedProduct.subcategoryID) {
        mainCategoryID = state.productInfo.subcategories[selectedProduct.subcategoryID]?.mainCategoryID || '';
    }

    return {
        user: state.user,
        loading: selectIsLoading(state),
        facility: cleanedFacility,
        productInfo: state.productInfo,
        tableFilters: state.manageInventory.tableFilters,
        selectedProduct,
        selectedJob,
        mainCategoryID,
        formValues: state.manageInventory.installFormValues,
        isAPIQueueEmpty: selectIsOnlineAndEmptyQueue(state),
        isJobReadOnly: selectIsJobReadOnly(state)
    };
};

export const EditInstallContainer = withTranslation('manageInventory')(
    connect(mapStateToProps, {
        updateInstall,
        saveInstall,
        toggleModal: toggleEditInstallModal,
        deleteInstall,
        saveAnyLocation,
        bulkUpdateInstalls, //  this could only be in EditInstallModal but the typings are strange
        setEnableInstallBatchMode,
        setInstallFormValues,
        updateInstallFormValues
    })(EditInstallForm)
);
